import React from 'react';
import Grid from "@material-ui/core/Grid";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from "@material-ui/core/Typography";
import Button from '@material-ui/core/Button';
import './GraduateInteractiveTool.scss';

interface InteractiveToolProps {
    item: number;
    title: string;
    description: string;
    link?: string;
}

const InteractiveTool: React.FC<InteractiveToolProps> = ({item, title, description, link}) => { 

    return (
        <>
            <Grid item xs={12} style={{marginRight:'10px'}}>
                <Accordion className="interactive-tool-section-accordion-container">
                    <AccordionSummary
                        expandIcon={ <ExpandMoreIcon />}
                        aria-controls={`panel${item}bh-content`}
                        id={`panel${item}bh-header`}
                        className="accordion-summary"
                    >
                        <Typography variant="h2" className="summary-title bold-serif">{title}</Typography>
                    </AccordionSummary>
                    <AccordionDetails className="interactive-tool-information-accordion-details">
                        <Grid container item xs={12} direction="row">
                            <Grid container item xs={12} className="tool-container">
                                <Grid container>
                                    <Typography variant="h5" className="description-tool-text regular-serif">{description}</Typography>
                                </Grid>
                                <Grid container item xs={12} justify="flex-start">
                                    <div className="link-button-container">
                                        <Button
                                        variant="contained"
                                        component="a"
                                        href={link}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="link-button"
                                        >
                                            <Typography variant="h5" className="regular-serif">
                                                Ir al enlace
                                            </Typography>
                                        </Button>
                                    </div>
                                </Grid>
                            </Grid>

                        </Grid>
                    </AccordionDetails>
                </Accordion>
            </Grid>
        </>
    )
}

export default InteractiveTool